<template>
  <div>
    <form data-vv-scope="custom-document" autocomplete="off" @submit.prevent>
      <h2 class="mb-10">Selección Proveedor Gasto de Representación</h2>
      <div class="row form-group">
        <div class="col-12 col-md-6">
          <b-form-group label="Fecha Solicitud *">
            <date-picker
              :input-class="{
                'mx-input':true,
                'border-danger':errors.has('custom-document.requestDate')
              }"
              data-cy="request-date"
              class="w-100"
              name="requestDate"
              format="DD-MM-YYYY"
              value-type="YYYY-MM-DD"
              data-vv-as="fecha solicitud"
              :danger="errors.has('custom-document.requestDate')"
              :danger-text="errors.first('custom-document.requestDate')"
              v-validate="'required'"
              v-model="formData.requestDate"
            />
            <ValidationError
              document="custom-document"
              validation="requestDate"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-6">
          <b-form-group label="Actividad *">
            <b-form-input
              :state="errors.has('custom-document.activity') ? false : null"
              data-cy="activity"
              data-vv-as="actividad"
              name="activity"
              type="text"
              v-model="formData.activity"
              v-validate="'required'"
            />
            <ValidationError
              document="custom-document"
              validation="activity"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
      </div>
      <h4>Departamento Administrativo</h4>
      <div class="row form-group">
        <div class="col-12">
          <b-table
            responsive striped hover small
            :items="formData.quotes"
            :fields="quotesFormFields"
          >
            <template v-slot:cell(actions)="row">
              <span
                :id="`delete-row-${row.index}`"
                class="flex items-center justify-content-center"
              >
                <b-button
                  class="btn-block"
                  size="sm"
                  @click="deleteQuotesRow(row.index)"
                  variant="danger"
                  :disabled="formData.quotes.length <= 3"
                  :data-cy="'delete-row-' + row.index"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
              </span>
              <b-tooltip
                v-if="formData.quotes.length <= 3"
                :target="`delete-row-${row.index}`"
              >
                El mínimo de cotizaciones es 3
              </b-tooltip>
            </template>
            <template v-slot:cell(name)="row">
              <b-form-input
                :data-vv-name="'quotes['+ row.index + '].name'"
                :state="errors.has(`custom-document.quotes[${row.index}].name`) ? false : null"
                name="quoteName"
                :data-cy="'quote-name-' + row.index"
                data-vv-as="nombre cotización"
                v-validate="'required'"
                v-model="row.item.name"
              />
            </template>
            <template v-slot:cell(documentType)="row">
              <b-form-input
                name="documentType"
                :data-vv-name="'quotes['+ row.index + '].documentType'"
                :state="errors.has(`custom-document.quotes[${row.index}].documentType`)
                  ? false : null"
                :data-cy="'document-type-' + row.index"
                data-vv-as="tipo documento tributario"
                v-validate="'required'"
                v-model="row.item.documentType"
              />
            </template>
            <template v-slot:cell(providerName)="row">
              <b-form-input
                name="providerName"
                :data-cy="'provider-name-' + row.index"
                data-vv-as="nombre proveedor"
                v-validate="'required'"
                :data-vv-name="'quotes['+ row.index + '].providerName'"
                :state="errors.has(`custom-document.quotes[${row.index}].providerName`)
                  ? false : null"
                v-model="row.item.providerName"
              />
            </template>
            <template v-slot:cell(rut)="row">
              <b-form-input-rut
                :data-cy="'quote-rut-' + row.index"
                v-model="row.item.rut"
                :data-vv-name="'quotes['+ row.index + '].rut'"
                :danger="errors.has(`custom-document.quotes[${row.index}].rut`)"
                :danger-text="errors.first(`custom-document.quotes[${row.index}].rut`)"
                :state="errors.has(`custom-document.quotes[${row.index}].rut`) ? false : null"
                v-validate="'required|validateRut'"
                placeholder="12345678-1"
              />
            </template>
            <template v-slot:cell(amount)="row">
              <InputCurrency
                label=""
                :options="{
                  locale: 'es-CL',
                  currency: 'CLP',
                  hideGroupingSeparatorOnFocus: false,
                  currencyDisplay: 'hidden',
                  precision: {
                    min: 0,
                    max: 2
                  }
                }"
                v-model="row.item.amount"
                id="quoteAmount"
                name="quoteAmount"
                :data-cy="'quote-amount-' + row.index"
                @input="validateCurrency(
                  $event,
                  'monto',
                  'custom-document',
                  'quotes[' + row.index + '].quoteAmount'
                  )"
                :state="errors
                  .has(`custom-document.quotes[${row.index}].quoteAmount`) ? false : null"
                :danger="errors.has(`custom-document.quotes[${row.index}].quoteAmount`)"
                data-vv-as="monto"
              />
            </template>
            <template v-slot:cell(compliesEETT)="row">
              <b-form-checkbox
                :data-cy="'quote-complies-eett-' + row.index"
                switch
                v-model="row.item.compliesEETT"
              />
            </template>
            <template v-slot:cell(attachedQuote)="row">
              <select-doc-from
                :data-cy="'select-doc-from-' + row.index"
                :modal-name="`select-doc-from-${row.index}`"
                :id="row.index"
                v-if="!row.item.attachedQuotes.length || !row.item.attachedQuotes[0].id"
                :max-files="1"
                :files="row.item.attachedQuotes"
                :add-file="(file) => {
                  addQuoteFile(file, row.item);
                  row.item.attachedQuote = file
                }"
                :remove-file="(id) => {
                  removeQuoteFile(id, row.item);
                  row.item.attachedQuote = {};
                  row.item.attachedQuotes = [];
                }"
                v-model="row.item.attachedQuotes[0]"
                :data-vv-name="'quotes['+ row.index + '].attachedQuote'"
                :danger="errors.has(`custom-document.quotes[${row.index}].attachedQuote`)"
                v-validate="'required'"
              />
              <div v-else class="d-flex align-items-center">
                <vs-icon icon="description" size="25px" color="primary"/>
                <b class="text-truncate w-32 text-center">{{ row.item.attachedQuotes[0].name }}</b>
                <vs-button
                  :data-cy="'remove-annex-file-' + row.index"
                  color="danger"
                  type="flat"
                  icon="clear"
                  @click="() => { row.item.attachedQuotes = []}"
                />
              </div>
              <div v-if="errors.has(`custom-document.quotes[${row.index}].attachedQuote`)">
                <span class="text-danger">Debe adjuntar un documento</span>
              </div>
            </template>
          </b-table>
        </div>
        <br/>
        <div class="col-8">
          <ValidationError
            document="custom-document"
            custom-error="Debe ingresar todos los datos solicitados en la tabla"
            :validation-array="formData.quotes.map((_, index) => [
              `quotes[${index}].name`,
              `quotes[${index}].documentType`,
              `quotes[${index}].providerName`,
              `quotes[${index}].rut`,
            ]).flat()"
            :validator-errors="errors"
          />
        </div>
        <div class="col-4">
          <b-button
            @click="addQuotesRow"
            variant="primary"
            data-cy="add-row"
            class="-mt-2 float-right"
          >
            Agregar Fila
          </b-button>
        </div>
      </div>
      <h4>Selección del Proveedor</h4>
      <div class="row form-group">
        <div class="col-12 col-md-4">
          <b-form-group label="Selección *" class="mt-0 mt-md-8">
            <b-form-checkbox
              name="providerSelection"
              data-cy="provider-selection"
              data-vv-as="seleccion de proveedor"
              v-model="formData.providerSelection"
              class="m-0"
              switch
              v-validate="'required'"
            >
              Menor precio
            </b-form-checkbox>
          </b-form-group>
        </div>
        <div class="col-12 col-md-8">
          <b-form-group label="Fundamentación de Selección *">
            <b-form-input
              :state="errors.has('custom-document.selectionJustification') ? false : null"
              data-cy="selection-justification"
              data-vv-as="fundamentación de selección"
              name="selectionJustification"
              type="text"
              v-model="formData.selectionJustification"
              v-validate="'required'"
            />
            <ValidationError
              document="custom-document"
              validation="selectionJustification"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-12 col-md-6">
          <b-form-group label="Proveedor Seleccionado *">
            <b-form-select
              class="w-100"
              data-cy="selected-provider"
              name="selectedProvider"
              data-vv-as="proveedor seleccionado"
              v-model="formData.selectedProvider"
              :state="errors.has('custom-document.selectedProvider') ? false : null"
              v-validate="'required'"
            >
              <option
                :value="null"
                v-if="invalidProvidersName"
              >
                -- Debes ingresar un proveedor en la tabla --
              </option>
              <option
                :value="null"
                disabled
                v-else
              >
                -- Selecciona un proveedor --
              </option>
              <option
                v-bind:key="option.providerName"
                v-for="option in formQuotesWithProvider"
                :value="option"
              >
                {{ option.providerName }}
              </option>
            </b-form-select>
            <ValidationError
              document="custom-document"
              validation="selectedProvider"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-6">
          <b-form-group label="Monto *">
            <InputCurrency
              label=""
              disabled
              :options="{
                locale: 'es-CL',
                currency:'CLP',
                hideGroupingSeparatorOnFocus: false,
                currencyDisplay: 'hidden',
                precision: {
                  min: 0,
                  max: 2
                }
              }"
              v-model="selectedProviderAmount"
              id="selectedProviderAmount"
              name="selectedProviderAmount"
              data-cy="selectedProviderAmount"
              :state="errors.has('custom-document.selectedProviderAmount') ? false : null"
              :danger="errors.has('custom-document.selectedProviderAmount')"
              :danger-text="errors.first('custom-document.selectedProviderAmount')"
              data-vv-as="monto"
            />
            <ValidationError
              document="custom-document"
              validation="selectedProviderAmount"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
      </div>
      <h4>Datos bancarios</h4>
      <div class="row form-group">
        <div class="col-12 col-md-6">
          <b-form-group label="RUT *">
            <b-form-input-rut
              id="bankRut"
              name="bankRut"
              data-cy="bank-rut"
              data-vv-as="rut"
              v-model="formData.bank.rut"
              :danger="errors.has('custom-document.bankRut')"
              :danger-text="errors.first('custom-document.bankRut')"
              :state="errors.has('custom-document.bankRut') ? false : null"
              v-validate="'required|validateRut'"
              placeholder="12345678-1"
            />
            <ValidationError
              document="custom-document"
              validation="bankRut"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-6">
          <b-form-group label="Correo *">
            <b-form-input
              data-vv-as="correo"
              id="bankEmail"
              name="bankEmail"
              data-cy="bank-email"
              placeholder="Correo"
              type="email"
              v-model="formData.bank.email"
              :state="errors.has('custom-document.bankEmail') ? false : null"
              v-validate="'required|email|max:80'"
            />
            <ValidationError
              document="custom-document"
              validation="bankEmail"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-12 col-md-4">
          <b-form-group label="Banco *">
            <b-form-select
              :disabled="loadingBankOptions"
              class="w-100"
              data-cy="bank-name"
              name="bankName"
              data-vv-as="banco"
              v-model="formData.bank.name"
              :state="errors.has('custom-document.bankName') ? false : null"
              v-validate="'required'"
              :options="bankOptions"
            >
              <option
                :value="null"
                disabled
              >
                {{ bankLoadingText }}
              </option>
            </b-form-select>
            <ValidationError
              document="custom-document"
              validation="bankName"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-4">
          <b-form-group label="Tipo Cuenta *">
            <b-form-select
              class="w-100"
              data-vv-as="tipo cuenta"
              id="bankAccountType"
              name="bankAccountType"
              data-cy="bank-account-type"
              :state="errors.has('custom-document.bankAccountType') ? false : null"
              :options="bankAccountTypes"
              v-model="formData.bank.accountType"
              v-validate="'required'"
            >
              <option value="" disabled>-- Selecciona un tipo de cuenta --</option>
            </b-form-select>
            <ValidationError
              document="custom-document"
              validation="bankAccountType"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-4">
          <b-form-group label="N° Cuenta *">
            <b-form-input
              data-vv-as="número de cuenta"
              type="number"
              id="bankAccountNumber"
              name="bankAccountNumber"
              data-cy="bank-account-number"
              v-model="formData.bank.accountNumber"
              :state="errors.has('custom-document.bankAccountNumber') ? false : null"
              v-validate="'required'"
            />
            <ValidationError
              document="custom-document"
              validation="bankAccountNumber"
              :validator-errors="errors"
            />
          </b-form-group>
        </div>
      </div>
      <div class="row align-items-center mt-1">
        <div class="col-md-3 align-items-end">
          <b-button
            variant="secondary"
            class="btn-icon mt-1"
            data-cy= "from-repository"
            v-has-permission="'ED060'"
            v-b-modal="'add-file-repository'"
          >
            <feather-icon icon="ServerIcon"/>
            Adjuntar archivo desde repositorio
          </b-button>
        </div>
        <div class="col-2" v-for="file in files" :key="file.id">
          <div class="d-flex flex-column align-items-center">
            <vs-icon icon="description" size="25px" color="primary" />
            <b class="text-truncate w-100 text-center">{{ file.name }}</b>
            <vs-button
              color="danger"
              type="flat"
              icon="clear"
              @click="removeFile(file.id)"
            />
          </div>
        </div>
      </div>
      <div class="row justify-end">
        <vs-button
          class="mt-5 mr-5"
          data-cy="cancel"
          @click="back()"
          color="primary"
          :disabled="saving"
        >
          Cancelar
        </vs-button>
        <vs-button
          class="mt-5 mr-5"
          data-cy="save"
          @click="save()"
          color="success"
          :disabled="saving"
        >
          Crear
          <span
            v-show="saving"
            class="spinner-border spinner-border-sm text-primary"
          />
        </vs-button>
      </div>
    </form>
    <!--<SelectDocRepository
      :add-file="addFileRepo"
      :files="files"
      :remove-file="removeFile"
    />-->
    <repository-selector
      modal-id="add-file-repository"
      :add-file="addFileRepo"
      :files="files"
      :remove-file="removeFile"
    />
  </div>
</template>

<script>

import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

import DatePicker from 'vue2-datepicker';
import { BFormCheckbox } from 'bootstrap-vue';

import { ioCreateCustomDocument, ioGetCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import InputCurrency from '@/components/InputCurrency';
import BFormInputRut from '@/components/inputs/BFormInputRut';
import ValidationError from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/ValidationError';
import SelectDocFrom from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/SelectDocFrom';
import { ioListOptions } from '@/febos/servicios/api/herramientas.api';
import SelectDocRepository from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/SelectDocRepository';
import RepositorySelector from "@/febos/global/customDocuments/components/repository-selector/RepositorySelector.vue";

export default {
  name: 'SEGR',
  components: {
    RepositorySelector,
    SelectDocRepository,
    SelectDocFrom,
    ValidationError,
    BFormInputRut,
    BFormCheckbox,
    InputCurrency,
    DatePicker,
  },
  data() {
    return {
      quoteCounter: 0,
      bankAccountTypes: ['Cuenta Vista', 'Cuenta Corriente', 'Cuenta de Ahorro'],
      loadingBankOptions: false,
      bankOptions: [],
      quotesFormFields: [
        {
          key: 'name',
          label: 'Nombre Cotización'
        },
        {
          key: 'documentType',
          label: 'Tipo Documento Tributario'
        },
        {
          key: 'providerName',
          label: 'Nombre Proveedor'
        },
        {
          key: 'rut',
          label: 'Rut'
        },
        {
          key: 'amount',
          label: 'Monto',
        },
        {
          key: 'compliesEETT',
          label: 'Cumple EETT',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          key: 'attachedQuote',
          label: 'Cotización Adjunta'
        },
        {
          key: 'actions',
          label: '',
          thClass: 'w-24',
          tdClass: 'w-24'
        }
      ],
      formData: {
        requestDate: null,
        activity: '',
        quotes: [],
        selectionJustification: '',
        selectedProvider: null,
        providerSelection: true,
        bank: {
          rut: '',
          email: '',
          name: null,
          accountType: '',
          accountNumber: ''
        },
      },
      files: [],
      saving: false,
      error: {
        message: ''
      }
    };
  },
  computed: {
    formQuotesWithProvider() {
      return this.formData.quotes.filter((quote) => quote.providerName !== '');
    },
    invalidProvidersName() {
      return !this.formData.quotes.length || !this.formData.quotes.find((quote) => quote.providerName !== '');
    },
    selectedProviderAmount() {
      return this.formData.selectedProvider?.amount || 0;
    },
    bankLoadingText() {
      return this.loadingBankOptions
        ? 'Cargando bancos'
        : '-- Selecciona un banco --';
    }
  },
  methods: {
    back() {
      /* eslint-disable no-restricted-globals */
      history.back();
    },
    async addFileRepo(file) {
      if (!Object.keys(file).length) {
        return;
      }

      if (file.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
      }

      this.files.push(file);
      this.error.message = '';
    },
    removeFile(id) {
      this.files = this.files.filter((file) => file.id !== id);
    },
    async loadBanks() {
      try {
        this.loadingBankOptions = true;
        const response = await ioListOptions({
          grupoOpcion: 'io.bancos.gore',
          filtros: 'deshabilitado:0'
        });
        const { opciones } = response.data;
        this.bankOptions = opciones.map((option) => ({
          value: option.valor,
          text: option.descripcion,
        })).sort((a, b) => a.text.localeCompare(b.text));
      } finally {
        this.loadingBankOptions = false;
      }
    },
    validateCurrency(val, fieldName, scope, field) {
      console.log(val);
      this.$validator.errors.remove(field, scope);

      if (val === null) {
        this.$validator.errors.add({
          field,
          msg: `El campo ${fieldName} es requerido`,
          scope,
        });
        return;
      }

      if (val <= 0) {
        this.$validator.errors.add({
          field,
          msg: `El campo ${fieldName} debe ser mayor a 0`,
          scope,
        });
      }
    },
    addQuotesRow() {
      this.formData.quotes.push({
        name: `Cotización ${this.quoteCounter += 1}`,
        documentType: '',
        providerName: '',
        rut: '',
        amount: '',
        compliesEETT: '',
        attachedQuote: {},
        attachedQuotes: [],
      });
    },
    deleteQuotesRow(index) {
      if (this.formData.selectedProvider === this.formData.quotes[index]) {
        this.formData.selectedProvider = null;
      }

      this.formData.quotes.splice(index, 1);
    },
    async addQuoteFile(file, item) {
      if (!Object.keys(file).length) {
        return;
      }

      if (file.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
      }

      item.attachedQuotes.push(file);
      this.error.message = '';
    },
    removeQuoteFile(id, item) {
      item.attachedQuotes.splice(item.attachedQuotes.findIndex((file) => file.id === id), 1);
    },
    async generatePdf(id) {
      this.$bvToast.toast(
        'Generando archivo PDF',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
      const response = await ioGetCustomDocument('SEGR', id, { pdf: 'si' });
      this.$bvToast.toast(
        'Archivo generado',
        {
          title: 'Listo!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
      window.open(response.data.pdf, '_blank');
      this.back();
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async save() {
      const isValid = await this.validateForm('custom-document');
      if (!isValid) return;

      this.error.message = '';
      this.saving = true;

      const attachments = [...this.files];

      this.formData.quotes.forEach((quote) => {
        if (quote.attachedQuote && quote.attachedQuote.id && quote.attachedQuotes.length) {
          attachments.push(quote.attachedQuote);
        }
      });

      try {
        this.$bvToast.toast(
          'Guardando documento',
          {
            title: 'En camino...',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );
        const payload = {
          type: this.$route.params.type,
          query: {
            numerar: 'si',
            ...this.$route.query
          },
          formData: {
            ...this.formData,
            attachments,
          },
        };
        const response = await ioCreateCustomDocument(payload);
        await this.generatePdf(response.data.document.id);
      } finally {
        this.saving = false;
      }
    }
  },
  created() {
    this.addQuotesRow();
    this.addQuotesRow();
    this.addQuotesRow();
    this.loadBanks();
  },
};
</script>
<style>
.custom-control.custom-control-inline.custom-switch {
  width: 48%;
  margin-bottom: 0.5rem;
}
[dir] .table.table-sm td {
  padding: 0.5rem;
}
.input-group {
  flex-wrap: nowrap;
}
input[name=availableQuote] {
  min-width: 30px;
}
</style>
